import React from 'react';
import TableCell from '@mui/material/TableCell';

function Celda(props) {
   const {valor, registro, nombreCampo, titulo, children, ...other} = props;

   return <TableCell {...other}>{children}</TableCell>;
}

export default Celda;
